<script>
import options from "./CurrentFundPrices.options"
export default options
</script>

<template>
  <div v-if="isError && !hideError" class="">
      <article class="nyk-context-banner">
          <div class="nyk-context-banner__content">
              <div class="nyk-context-banner__content__info">
                  <p class="nyk-context-banner__content__info__description">
                      {{ errorMessage }}
                  </p>
              </div>
          </div>
          <button class="nyk-context-banner__link" v-on:click="handleHideSystemErrorMessage"></button>
      </article>
  </div>


  <DynamicTable
    v-if="!isMobile"
    v-for="(table, i) in tables"
    :key="i"
    :headers="table.headers"
    :rows="table.rows"
  />

  <template v-if="isMobile" v-for="(group, i) in mobileTableGroups" :key="i">
    <h2>{{ group.name }}</h2>
    <DynamicTable
      v-for="(table, i) in group.tables"
      :key="i"
      :headers="table.headers"
      :rows="table.rows"
    />
  </template>
</template>